export class ContributorPaymentUpsertModel {
    public contributorId: string;
    public amount: number;
    public remark: string;
}
